import { Link } from "react-router-dom";
import { formatPostDate } from "../home/LatestArticles";
import { getArticleAuthor } from "../../lib/authors";

const authorName = (p) => getArticleAuthor(p.slug, p.author).displayName;

const Badge = ({ children, big = false }) => (
    <span
        className={`absolute bg-navy text-gold rounded-md font-semibold uppercase tracking-[0.14em] ${
            big ? "left-[18px] top-[18px] px-3 py-1.5 text-xs" : "left-3.5 top-3.5 px-2.5 py-[5px] text-[11px]"
        }`}
    >
        {children}
    </span>
);

const Cover = ({ src, alt, className }) =>
    src ? (
        <img src={src} alt={alt} loading="lazy" className={`absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03] ${className || ""}`} />
    ) : null;

export const FeaturedPost = ({ p }) => (
    <Link
        to={`/post/${p.slug}`}
        data-testid={`article-featured-${p.slug}`}
        className="group flex flex-wrap bg-white border border-border-default rounded-[18px] overflow-hidden text-navy transition-shadow hover:shadow-lg"
    >
        <div className="flex-1 basis-[380px] min-h-[260px] relative bg-navy overflow-hidden">
            <Cover src={p.image_url} alt={p.title} />
            <Badge big>À la une{p.category ? ` · ${p.category}` : ""}</Badge>
        </div>
        <div className="flex-1 basis-[420px] p-[22px] md:p-10 flex flex-col gap-3.5 justify-center">
            <span className="text-[13px] text-grey-text-soft">
                {formatPostDate(p.created_at)} · <span data-testid="featured-author">Par {authorName(p)}</span>
            </span>
            <h2 className="m-0 text-[22px] md:text-[30px] font-bold leading-[1.25] tracking-[-0.015em] group-hover:text-gold-text transition-colors">{p.title}</h2>
            {p.excerpt && <p className="m-0 text-[15px] leading-[1.65] text-grey-text-soft line-clamp-3">{p.excerpt}</p>}
            <span className="text-[15px] font-semibold underline underline-offset-4 inline-flex items-center min-h-[44px]">Lire l'article</span>
        </div>
    </Link>
);

export const PostCard = ({ p }) => (
    <Link
        to={`/post/${p.slug}`}
        data-testid={`article-card-${p.slug}`}
        className="group bg-white border border-border-default rounded-2xl overflow-hidden flex flex-col text-navy transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
    >
        <div className="aspect-video relative bg-navy-band overflow-hidden">
            <Cover src={p.image_url} alt={p.title} />
            {p.category && <Badge>{p.category}</Badge>}
        </div>
        <div className="p-[22px] flex flex-col gap-2.5 grow">
            <h3 className="m-0 text-lg font-bold leading-[1.35] group-hover:text-gold-text transition-colors">{p.title}</h3>
            <span className="text-[13px] font-medium text-gold-text" data-testid={`card-author-${p.slug}`}>Par {authorName(p)}</span>
            <p className="m-0 text-sm leading-relaxed text-grey-text-soft grow line-clamp-4">{p.excerpt}</p>
            <div className="flex justify-between items-center text-[13px] text-grey-text-soft border-t border-border-soft pt-3">
                <span>{formatPostDate(p.created_at)}</span>
                <span className="font-semibold text-navy">Lire</span>
            </div>
        </div>
    </Link>
);
